import { ValidationRule } from 'react-hook-form';

export const formRuleMaxLength = (rule: ValidationRule<number> | undefined): number | undefined => {
    if (!rule) {
        return;
    }
    const valueOf = rule.valueOf();
    if (typeof valueOf === 'object') {
        if ('value' in valueOf && typeof valueOf.value === 'number') {
            return valueOf.value;
        }
        return;
    }
    return valueOf;
};
